import { defineMessages } from 'react-intl';

import {
  RevealableProperty,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';

import bestFiveClue from '#src/assets/card-pull-experience/best-five.svg';
import bestStarRankClue from '#src/assets/card-pull-experience/best-star-rank.svg';
import competitionClue from '#src/assets/card-pull-experience/competition.svg';
import divisionClue from '#src/assets/card-pull-experience/division.svg';
import countryClue from '#src/assets/card-pull-experience/nationality.svg';
import positionClue from '#src/assets/card-pull-experience/position.svg';
import mlbPositionClue from '#src/assets/card-pull-experience/positionMlb.svg';
import potionClue from '#src/assets/card-pull-experience/potion.svg';
import shuffleClue from '#src/assets/card-pull-experience/shuffle.svg';

const propertyLabels = defineMessages({
  competition: {
    defaultMessage: 'Reveal League',
  },
  country: {
    defaultMessage: 'Reveal Nationality',
  },
  fiftyFifty: {
    defaultMessage: 'Keep best five',
  },
  position: {
    defaultMessage: 'Reveal Position',
  },
  division: {
    defaultMessage: 'Reveal division',
  },
  potion: {
    defaultMessage: 'Cursed Potion',
  },
  shuffle: {
    defaultMessage: 'Snowglobe Shuffle',
  },
  bestStarRank: {
    defaultMessage: 'Reveal Highest rank',
  },
  shortCompetition: {
    defaultMessage: 'League',
  },
  shortCountry: {
    defaultMessage: 'Nationality',
  },
  shortShuffle: {
    defaultMessage: 'Shuffle',
  },
  shortFiftyFifty: {
    defaultMessage: 'Best 5',
  },
  shortPosition: {
    defaultMessage: 'Position',
  },
  shortDivision: {
    defaultMessage: 'Division',
  },
  shortPotion: {
    defaultMessage: 'Cursed Potion',
  },
  shortBestStarRank: {
    defaultMessage: 'Highest rank',
  },
  countryDescription: {
    defaultMessage:
      'View the Birthplace country of the players, as displayed on the card',
  },
  competitionDescription: {
    defaultMessage: 'View the League of each card',
  },
  fiftyFiftyDescription: {
    defaultMessage: 'Keep the 5 highest-tier cards ',
  },
  positionDescription: {
    defaultMessage: 'View the Position of each card',
  },
  divisionDescription: {
    defaultMessage: 'View the Division of each card',
  },
  potionDescription: {
    defaultMessage:
      '66.6% chance to keep the five highest rank-cards, 33.3% to keep the five lowest-rank cards.',
  },
  bestStarRankDescription: {
    defaultMessage: 'Display the highest rank of the drawn cards.',
  },
  shuffleDescription: {
    defaultMessage:
      'Shake the craft like a snowglobe! Hide the cards again, shuffle and try your luck a 2nd time (once activated clues are disabled).',
  },
});

const getPositionClueIcon = (sport: Sport) => {
  switch (sport) {
    case Sport.BASEBALL:
      return mlbPositionClue;
    default:
      return positionClue;
  }
};

export const getClueAssets = (sport: Sport) => {
  return {
    [RevealableProperty.COMPETITION]: {
      iconUrl: competitionClue,
      label: propertyLabels.competition,
      shortLabel: propertyLabels.shortCompetition,
      description: propertyLabels.competitionDescription,
    },
    [RevealableProperty.COUNTRY]: {
      iconUrl: countryClue,
      label: propertyLabels.country,
      shortLabel: propertyLabels.shortCountry,
      description: propertyLabels.countryDescription,
    },
    [RevealableProperty.FIFTY_FIFTY]: {
      iconUrl: bestFiveClue,
      label: propertyLabels.fiftyFifty,
      shortLabel: propertyLabels.shortFiftyFifty,
      description: propertyLabels.fiftyFiftyDescription,
    },
    [RevealableProperty.DIVISION]: {
      iconUrl: divisionClue,
      label: propertyLabels.division,
      shortLabel: propertyLabels.shortDivision,
      description: propertyLabels.divisionDescription,
    },
    [RevealableProperty.POSITION]: {
      iconUrl: getPositionClueIcon(sport),
      label: propertyLabels.position,
      shortLabel: propertyLabels.shortPosition,
      description: propertyLabels.positionDescription,
    },
    [RevealableProperty.HALLOWEEN_FIFTY_FIFTY]: {
      iconUrl: potionClue,
      label: propertyLabels.potion,
      shortLabel: propertyLabels.shortPotion,
      description: propertyLabels.potionDescription,
    },
    [RevealableProperty.BEST_STAR_RANK]: {
      iconUrl: bestStarRankClue,
      label: propertyLabels.bestStarRank,
      shortLabel: propertyLabels.shortBestStarRank,
      description: propertyLabels.bestStarRankDescription,
    },
    [RevealableProperty.RESHUFFLE]: {
      iconUrl: shuffleClue,
      label: propertyLabels.shuffle,
      shortLabel: propertyLabels.shortShuffle,
      description: propertyLabels.shuffleDescription,
    },
  };
};

export const AFTER_PICK_CLUES = [RevealableProperty.RESHUFFLE];
export const BEFORE_PICK_CLUES = Object.values(RevealableProperty).filter(
  prop => !AFTER_PICK_CLUES.includesValue(prop)
);
